
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Ship, CircleCheck, CircleX } from "lucide-react";

export const BoatRestrictions = () => {
  return (
    <RegulationItem 
      value="boat-restrictions" 
      icon={Ship}
      title="Boat Restrictions"
    >
      <div className="space-y-4">
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">Mountain View Reservoir:</h4>
          <ul className="space-y-2 text-tribal-neutral">
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Gasoline-powered motorboats and combustion-engine vessels allowed.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Electric-powered motorboats allowed.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Non-motorized boats, rafts, kayaks, and canoes allowed.</span>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">Sheep Creek Reservoir:</h4>
          <ul className="space-y-2 text-tribal-neutral">
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Gasoline-powered motorboats and combustion-engine vessels allowed.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Electric-powered motorboats allowed.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Non-motorized boats, rafts, kayaks, and canoes allowed.</span>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">Lake Billy Shaw:</h4>
          <ul className="space-y-2 text-tribal-neutral">
            <li className="flex items-start gap-2">
              <CircleX className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
              <span>Gasoline-powered motorboats and combustion-engine vessels prohibited.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Electric-powered motorboats allowed.</span>
            </li>
            <li className="flex items-start gap-2">
              <CircleCheck className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>Non-motorized boats, rafts, kayaks, and canoes allowed.</span>
            </li>
          </ul>
        </div>
      </div>
    </RegulationItem>
  );
};
